import config from 'chronos-config';
import * as api from 'chronos-api';

import configureStore from './configureStore';

const rootEl = window.document.getElementById('app');
if (
  process.env.NODE_ENV === 'development'
  && rootEl?.dataset?.jiratype !== 'server'
  && !window.AP
) {
  api.jiraApi
    .setHeaders({
      Accept: 'application/json',
      'Content-Type': 'application/json',
      Authorization: `Basic ${config.authBase64}`,
    });
}

const store = configureStore();

export default store;
